export enum ModalsTypeEnum {
	COMMUNICATE = 'communicate',
	DOCUMENTS = 'documents',
	WHAT_CAN_BE_REFUND = 'whatCanBeRefund',
}

export type ModalsType = 'communicate' | 'documents' | 'whatCanBeRefund';
